import React, { useEffect, useState, useMemo } from "react";
import { useParams } from "react-router-dom";

import {
	Box,
	Container,
	Typography,
	Paper,
	Stack,
	Button,
	Divider
} from "@mui/material";
import Grid from "@mui/material/Grid2"; // Updated to Grid2
import FullscreenHero from "../components/hero/hero";
import ApplicationForm from "../components/form/form";

import { fetchPreview } from "../controllers/job-controllers";
import { createContext } from "react";

import JobBenefits from "../components/job-details/job-benefits";

import Informations from "../components/informations/informations";
import AboutCompany from "../components/about-company/about-company";
import Benefits from "../components/benefits/benefits";
import Skills from "../components/skills/skills";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";


export const PageContext = createContext({});

export const PageConsumer = PageContext.Consumer;

export default function PreviewPage({ company }) {
	const params = useParams();
	const previewId = params.id;
	const [jobData, setJobData] = useState(null);
	const navigate = useNavigate();

	useEffect(() => {
		fetchPreview(previewId).then((res) => {
			
			if (res?.error) {

				if (res?.error == 'not_found') {
					navigate("/404", { replace: true });
				}

			} else {
				setJobData(res);
			}
		});
	}, []);

	const memoizedValue = useMemo(
		() => ({
			jobData,
			setJobData
		}),
		[jobData, setJobData]
	);

	return (
		<>
			<Helmet>
				<title>{company?.name ? `Preview | ${company?.name }` : 'Preview'}</title>
				<meta name="robots" content="noindex, nofollow" />
			</Helmet>
			<PageContext.Provider value={memoizedValue}>
				{jobData &&
				<FullscreenHero company={company} jobData={jobData?.jobDetails} />
				}
				<div
					style={{
						position: "fixed",
						top: ".7rem",
						borderRadius: "7px",
						right: "1rem",
						width: "fit-content",
						backgroundColor: "white",
						color: "black",
						zIndex: "5",
						padding: ".5rem 1rem",
						fontWeight: 600,
						letterSpacing: ".1rem",
						mixBlendMode: 'difference'
					}}
				>
					<p style={{ padding: "0", margin: 0 }}>Preview</p>
				</div>

				{/* Main Content Section with Sticky Sidebar */}
				<Container
					maxWidth="lg"
					sx={{
						mt: 5,
						display: "flex",
						gap: { xs: "20px", md: "80px" },
						flexDirection: "column",
						marginTop: { xs: 0, md: "-80px" },
						backgroundColor: "white",
						position: "relative",
						zIndex: "10",
						borderRadius: { xs: "0px", md: "20px" },
						boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
						padding: {
							xs: "40px 15px!important", // Up to md
							md: "80px 100px 80px 100px!important"
						}
					}}
				>
					{/* Info */}
					<Informations jobData={jobData} />

					<Divider />

					{/* Company info */}
					<AboutCompany company={company} />

					{jobData?.jobDetails?.benefits?.length > 0 &&
						jobData?.jobDetails?.skills.length > 0 && <Divider />}

					{/* Benefits */}
					{jobData?.jobDetails?.benefits.length > 0 && (
						<Benefits benefits={jobData?.jobDetails?.benefits} />
					)}

					{/* Skills */}
					{jobData?.jobDetails?.skills.length > 0 && (
						<Skills skills={jobData?.jobDetails?.skills} />
					)}
				</Container>

				<Box
					sx={{
						backgroundColor: "var(--c-main)" // Use primary color from the theme
					}}
				>
					<Container id={"apply"} sx={{ mt: 9, display: "flex", padding: 0 }}>
						{/* Application Form */}
						<ApplicationForm
							isPreview={true}
							jobData={jobData}
							jobQuestions={jobData?.screeningQuestions?.questions}
						/>
					</Container>
				</Box>
			</PageContext.Provider>
		</>
	);
}
